import { render, staticRenderFns } from "./BigButton.vue?vue&type=template&id=b0938a26&"
import script from "./BigButton.vue?vue&type=script&lang=js&"
export * from "./BigButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports